export default __webpack_public_path__ + "static/media/glrc-course.holistic_essentials.6b44498a.png";